import { gql } from '@apollo/client';
import {
  DatePickerFieldsFragment,
  LogicalOperatorFragment,
} from '../fragments';
import {
  DashboardFolderFieldsFragment,
  DashboardInstanceFieldsFragment,
  DashboardTemplateFieldsFragment,
} from './fragments';

export const dashboardQuery = gql`
  query Dashboard($id: ID!, $baseId: ID!) {
    dashboard(id: $id) {
      ...DashboardInstanceFields
    }
    folderOfDashboard(dashboardBaseId: $baseId) {
      ...DashboardFolderFields
    }
  }
  ${DashboardInstanceFieldsFragment}
  ${DashboardFolderFieldsFragment}
`;

export const dashboardFromTemplateQuery = gql`
  query DashboardFromTemplate($baseId: ID!) {
    dashboardFromTemplate(baseId: $baseId) {
      ...DashboardInstanceFields
    }
    folderOfDashboard(dashboardBaseId: $baseId) {
      ...DashboardFolderFields
    }
  }
  ${DashboardInstanceFieldsFragment}
  ${DashboardFolderFieldsFragment}
`;

export const GET_DASHBOARD_CONFIG = gql`
  query DashboardConfig {
    dashboardConfig {
      defaultStart
      defaultEnd
      defaultDatePicker {
        ...DatePickerFields
      }
      logicOps {
        ...LogicalOperatorFields
      }
    }
  }
  ${LogicalOperatorFragment}
  ${DatePickerFieldsFragment}
`;

export const dashboardFolderQuery = gql`
  query DashboardFolder($id: ID) {
    dashboardFolder(folderId: $id) {
      ...DashboardFolderFields
    }
  }
  ${DashboardFolderFieldsFragment}
`;

export const DASHBOARD_REDIRECT_QUERY = gql`
  query DashboardRedirectQuery($id: ID!) {
    dashboard(id: $id) {
      baseId
    }
  }
`;

export const GET_DASHBOARD_INSTANCE = gql`
  query GetDashboardInstance($baseId: ID!) {
    dashboardFromTemplate(baseId: $baseId) {
      ...DashboardInstanceFields
    }
  }
  ${DashboardInstanceFieldsFragment}
`;

export const GET_DASHBOARD_TEMPLATES_BY_SCOPE = gql`
  query GetDashboardTemplatesByScope(
    $term: String
    $scopes: [DashboardTemplateScope!]!
  ) {
    dashboardTemplatesByScope(term: $term, scopes: $scopes) {
      entities {
        ...DashboardTemplateFields
      }
      scope
    }
  }
  ${DashboardTemplateFieldsFragment}
`;
